import { createSlice } from '@reduxjs/toolkit';
import { ITypeOfPayment } from '../../../../dto';
import { setTypeOfPayments } from '../actions';
import { MN_TYPE_OF_PAYMENTS, TYPE_LIST } from '../../../../common';

export interface TypeOfPaymentsState {
  data: ITypeOfPayment[];
  loading: boolean;
  error: string | null;
}

const initialState: TypeOfPaymentsState = {
  data: [],
  loading: false,
  error: null,
};

export const typeOfPaymentsSlice = createSlice({
  name: `${MN_TYPE_OF_PAYMENTS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTypeOfPayments, (state, { payload }) => {
      state.data = payload;
    });
  },
});
